import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	deploymentPopupTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewAllDeployments: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issuesDeployed: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issuesDeployedIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	deploymentPopupTitle: {
		id: 'software-releases-launch-card.latest-deployment.deployment-tooltip-content.deployment-popup-title',
		defaultMessage: 'Deployment',
		description:
			'Title of the popup indicating that the details of the popup represent a deployment.',
	},
	viewAllDeployments: {
		id: 'software-releases-launch-card.latest-deployment.deployment-tooltip-content.view-all-deployments',
		defaultMessage: 'View all deployments',
		description:
			'Clickable text to open the detail development information dialog to show all the deployments, and others.',
	},
	issuesDeployed: {
		id: 'software-releases-launch-card.latest-deployment.deployment-tooltip-content.issues-deployed',
		defaultMessage: '{issueCount} {issueCount, plural, one {issue} other {issues}} deployed',
		description:
			'Clickable text to open the detail development information dialog to show all the deployments, and others.',
	},
	issuesDeployedIssueTerminologyRefreshM4: {
		id: 'software-releases-launch-card.latest-deployment.deployment-tooltip-content.issues-deployed-issue-terminology-refresh-m4',
		defaultMessage:
			'{issueCount} {issueCount, plural, one {work item} other {work items}} deployed',
		description:
			'Clickable text to open the detail development information dialog to show all the deployments, and others.',
	},
});
export default messages;
